import { InstallationCashFlowSummary } from "./InstallationCashFlowSummary";

export class FrontOfficeCashFlowSummaryInstallation extends InstallationCashFlowSummary {
    paymentsExpectedAmount: number;
    paymentsAmount: number;
    notPaidChange: number;
    withdrawal: number;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.PaymentsExpectedAmount != null) this.paymentsExpectedAmount = obj.PaymentsExpectedAmount;

        if (obj.PaymentsAmount != null) this.paymentsAmount = obj.PaymentsAmount;

        if (obj.NotPaidChange != null) this.notPaidChange = obj.NotPaidChange;

        if (obj.Withdrawal != null) this.withdrawal = obj.Withdrawal;
    }
}
